import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=3df93dfd&"
import script from "./MapLegend.vue?vue&type=script&lang=ts&"
export * from "./MapLegend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports